import React, {useEffect, useImperativeHandle, useState} from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin, Typography, notification,
} from "antd";
import Notification from "../../../../../../components/common/notification/notification";
import {InputFields} from "components/common";

import {employeeService} from "api"
import dayjs from "dayjs";
import {useAppDispatch, useAppSelector} from "../../../../../../redux/hooks";
//import {dataFields as inputFieldsInit } from "./FormList.config";
import {getKyLuat, getSGAPI} from "../../../../../../redux/reducer/employee";
import { message } from 'antd';
import { DataFormField } from "types/models/input-field-type";
import { FIELD_TYPE,FORMAT_TIME } from "types/enums";
const { INPUT, DATE,DATE_DISABLE_NO_DAY, COMBO_BOX,SELECT, AUTO_COMPLETE, CURRENCY, NUMBER ,DATE_PRE ,DATE_ON ,DATE_DISABLE} = FIELD_TYPE;
const FormList = props => {
  const {data, closeModal, type, getListApi} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const employees = useAppSelector(
      (state) => state.employeesReducer
  );
  const onChangeMNV = async (e) => {
    //  let MNV = form.getFieldValue("tenNhanVien");
    // // console.log("Mã nhân viên",MNV);
    
    //  form.setFieldValue("maNhanVien", MNV);
    try {
      const res = await employeeService.getDisciplinedemployees([e]);
      if (res.data && Array.isArray(res.data)) {
        // Find the object in res.data that corresponds to the selectedTenNhanVien
        const selectedObject = res.data.find((item) => item.tenNhanVien === e);
        if (selectedObject) {
          let MNV = selectedObject.maNhanVien;
          form.setFieldValue("maNhanVien", MNV);
         // console.log("MNV", MNV);
        } else {
         // console.log("Không tìm thấy dữ liệu cho tên nhân viên đã chọn");
        }
      } else {
       // console.log("Dữ liệu không hợp lệ");
      }
    } catch (error) {
      Notification("error", "Đã xảy ra lỗi khi lấy dữ liệu");
    }
  };
  
  const css = { xs: 24, sm: 24, md: 24, lg: 8, xl: 8 };
  const dataFields: DataFormField[] = [
    {
      type: INPUT,
      label: "Mã nhân viên",
      name: "maNhanVien",
      disable: true,
      css: css,
    //  onChange:onChangeMNV,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
    },
    {
      type: COMBO_BOX,
      name: "tenNhanVien",
      label: "Họ tên",
      disable: false,
      css: css,
      onChange:onChangeMNV,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
    },
    {
      type: INPUT,
      name: "soQuyetDinh",
      label: "Số quyết định",
      disable: false,
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
    },
    {
      type: DATE,
  
      name: "ngayKyLuat",
      label: "Ngày kỷ luật",
      disable: false,
      optionsTime: {
          showTime: true,
          format: FORMAT_TIME.dayFull,
        },
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
    },
    {
      type: SELECT,
  
      name: "hinhThucXuLy",
      label: "Hình thức xử lý",
      disable: false,
        options: [
        { value: "Khiển trách", label: "Khiển trách" },
        { value: "Kéo dài thời hạn nâng lương không quá 06 tháng", label: "Kéo dài thời hạn nâng lương không quá 06 tháng" },
        { value: "Cách chức", label: "Cách chức" },
        { value: "Sa thải", label: "Sa thải" },
      ],
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
    },
    {
      type: INPUT,
  
      name: "caNhanLienQuan",
      label: "Cá nhân liên quan",
      disable: false,
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
    },
    {
      type: DATE_DISABLE_NO_DAY,
      name: "thoiGianThuThach",
      label: "Thời gian thử thách",
      disable: false,
      optionsTime: {
          showTime: true,
          format: FORMAT_TIME.dayFull,
        },
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
    },
    {
      type: INPUT,
  
      name: "theoDoi",
      label: "Theo dõi",
      disable: false,
      css: css,
      wrapperCol: { xs: 24, sm: 14, md: 16, lg: 16, xl: 16 },
      labelCol: { xs: 24, sm: 10, md: 8, lg: 8, xl: 8 },
    },
  ];
  const [fieldInfo, setFieldInfo] = useState(dataFields);
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (type == "Thêm mới") {
      form.resetFields();
    } else {
      form.setFieldsValue(data);
    }
  }, [data]);
  useEffect(() => {

    form.setFieldsValue({
      ...data,

    });
  }, [data]);
  useEffect(() => {
    dispatch(getKyLuat({
      page: 1,
      limit: 100,
    }));    
    }, []);
    useEffect(() => {
      setOptionsKLFields(employees.kyLuat, "tenNhanVien");
    }, [employees.kyLuat]);   
    const setOptionsKLFields = (list, hoTen) => {
      if (dataFields.find((field) => field.name === hoTen)) {
        dataFields.find((field) => field.name === hoTen).options =
          list?.map((item) => ({
            value: item.tenNhanVien,
            label: item.tenNhanVien,
            key: `${item.tenNhanVien}-${item.maNhanVien}`,
          }));
         // setFieldInfo([...fieldInfo]);
      }
    };
useEffect(() => {
      form.setFieldsValue({
        ...data,
        thoiGianThuThach: data?.thoiGianThuThach
          ? dayjs(data.thoiGianThuThach)
          : null,
          ngayKyLuat: data?.ngayKyLuat
          ? dayjs(data.ngayKyLuat)
          : null,
      });
  }, [data]);
  const addApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
      };
      await employeeService.updateDiscipline(params).then(res => {
        if(res.code === 400)
        {
          Notification("error",res.message);
        }else
        {
          Notification("success","Đã thêm mới thành công ");
        }
      });
      setLoading(false);
      closeModal();
      form.resetFields();
      await getListApi(params);
    } catch (error) {
      setLoading(false);
      Notification("error","Đã có lỗi khi thêm mới kỷ luât");
    }
  };
  const editApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        id:data.id,
      };
      const res = await employeeService.updateDiscipline(params).then(res => {
        if(res.code === 400)
        {
          Notification("error",res.message);
        }else
        {
          Notification("success","Đã chỉnh sửa thành công ");
        }

      });
      setLoading(false);
      closeModal();
      await getListApi(params);

    } catch (error) {
      setLoading(false);
      Notification("error","Đã có lỗi khi sửa thông tin kỷ luật ");
    }
  };
  const onFinish = values => {
    if (type == "Thêm mới") {
      addApi();
    } else {
      editApi();
    }
  };
  return (
      <div>
        <Spin spinning={loading}>
          <Form form={form} onFinish={onFinish}>
            <Space direction="vertical" style={{width: "100%"}}>
              <Row gutter={[16, 8]}>
                <InputFields data={fieldInfo}></InputFields>
              </Row>
              <Row justify="end" style={{ marginTop: 12 }}>
                <Col>
                  <Space>
                    <Button onClick={closeModal} style={{ backgroundColor: "red", borderColor: "red" , color: "white"  }}>Hủy bỏ</Button>
                    <Button htmlType="submit" type="primary" >
                      Lưu lại
                    </Button>
                  </Space>{" "}
                </Col>
              </Row>
            </Space>
          </Form>
        </Spin>
      </div>
  );
};
export default FormList;
